import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Search, SlidersHorizontal, X } from "lucide-react";
import { useApi } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageHead, Input, Select, Field, DataList, Btn } from "../components/kit";
import { OrderCard } from "../components/OrderCard";
import { STATUSES, DONE } from "../lib/constants";

const EMPTY = { q: "", status: "", operator_id: "", date_from: "", date_to: "" };

function Filters({ f, set, tab, showOperator }) {
  const { data: ops } = useApi(showOperator ? "/users/operators" : null, 0);
  const statuses = tab === "done" ? DONE : STATUSES.filter((s) => !DONE.includes(s));
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 p-4 bg-white rounded-2xl border border-slate-200" data-testid="order-filters">
      <Field label="Status"><Select data-testid="filter-status" placeholder="Semua" options={statuses} value={f.status} onChange={(e) => set({ ...f, status: e.target.value })} /></Field>
      {showOperator && <Field label="Operator"><Select data-testid="filter-operator" placeholder="Semua" options={(ops || []).map((o) => [o.id, o.name])} value={f.operator_id} onChange={(e) => set({ ...f, operator_id: e.target.value })} /></Field>}
      <Field label="Dari tanggal"><Input data-testid="filter-date-from" type="date" value={f.date_from} onChange={(e) => set({ ...f, date_from: e.target.value })} /></Field>
      <Field label="Sampai tanggal"><Input data-testid="filter-date-to" type="date" value={f.date_to} onChange={(e) => set({ ...f, date_to: e.target.value })} /></Field>
      <button className="col-span-2 md:col-span-4 text-sm font-semibold text-slate-500 inline-flex items-center gap-1 justify-self-start" onClick={() => set({ ...EMPTY, q: f.q })} data-testid="filter-reset"><X className="w-4 h-4" /> Reset filter</button>
    </div>
  );
}

export default function Orders() {
  const { user } = useAuth();
  const [tab, setTab] = useState("open");
  const [f, setF] = useState(EMPTY);
  const [showF, setShowF] = useState(false);
  const qs = new URLSearchParams({ tab, ...f }).toString();
  const { data } = useApi(`/orders?${qs}`);
  const tabCls = (t) => `flex-1 h-12 rounded-xl font-bold transition-colors ${tab === t ? "bg-slate-900 text-white" : "text-slate-600"}`;
  return (
    <>
      <PageHead title="Daftar Order" sub={user.role === "operator" ? "Order yang ditugaskan kepada Anda" : "Semua order produksi"}
        action={user.role === "admin" && <Link to="/order/baru" className="hidden sm:block"><Btn data-testid="new-order-btn"><Plus className="w-5 h-5" /> Order Baru</Btn></Link>} />
      <div className="flex p-1 bg-slate-200/70 rounded-2xl gap-1" data-testid="order-tabs">
        <button className={tabCls("open")} onClick={() => { setTab("open"); setF({ ...f, status: "" }); }} data-testid="tab-open">Belum Selesai</button>
        <button className={tabCls("done")} onClick={() => { setTab("done"); setF({ ...f, status: "" }); }} data-testid="tab-done">Selesai</button>
      </div>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="w-5 h-5 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input data-testid="order-search-input" className="pl-11" placeholder="Cari pelanggan / no. order" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} />
        </div>
        <Btn variant={showF ? "dark" : "secondary"} onClick={() => setShowF(!showF)} data-testid="toggle-filters-btn" className="px-4"><SlidersHorizontal className="w-5 h-5" /></Btn>
      </div>
      {showF && <Filters f={f} set={setF} tab={tab} showOperator={user.role !== "operator"} />}
      <DataList data={data} emptyText="Tidak ada order." emptyTestId="orders-empty">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="order-list">
          {(data || []).map((o) => <OrderCard key={o.id} o={o} />)}
        </div>
      </DataList>
      {user.role === "admin" && (
        <Link to="/order/baru" data-testid="new-order-fab" className="sm:hidden fixed bottom-24 right-4 z-30 w-16 h-16 rounded-2xl bg-sky-500 text-white grid place-items-center shadow-xl shadow-sky-500/40 active:scale-95">
          <Plus className="w-8 h-8" />
        </Link>
      )}
    </>
  );
}
